"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TipAlert;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var StyledTipAlert = (0, _styledComponents.default)(_UIAlert.default).withConfig({
  displayName: "TipAlert__StyledTipAlert",
  componentId: "sc-1hpfw7d-0"
})(["border-radius:3px;"]);

var TipAlertTitle = _styledComponents.default.span.withConfig({
  displayName: "TipAlert__TipAlertTitle",
  componentId: "sc-1hpfw7d-1"
})(["font-weight:800;margin-left:2px;margin-right:2px;"]);

function TipAlert(props) {
  var title = props.title,
      children = props.children,
      type = props.type,
      rest = (0, _objectWithoutProperties2.default)(props, ["title", "children", "type"]);
  return _react.default.createElement(StyledTipAlert, Object.assign({}, rest, {
    className: "m-top-4",
    type: type,
    use: "inline"
  }), title && _react.default.createElement(TipAlertTitle, null, title + ": "), children);
}

TipAlert.propTypes = {
  children: _propTypes.default.node,
  title: _propTypes.default.node.isRequired,
  type: _propTypes.default.string
};
TipAlert.defaultProps = {
  type: 'info'
};
module.exports = exports.default;